import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/employer_actions";
import ReactTooltip from "react-tooltip";
import cellGenerator from "./columnUtils";

const employer_columns = (isSubaccount) => [
  {
    id: "profilename",
    Header: "Profile Name",
    accessor: (d) => d,
    Cell: ({ row: { original } }) => {
      const formData = original.EmployerFormData;
      let profileName = formData.new_profile_emp_profile_name;
      let legalBusinessName = formData.new_profile_emp_legal_name;
      let fein = formData.new_profile_emp_fein;
      return (
        <Fragment>
          <span
            className="cell"
            title={profileName}
            data-tip
            data-for={profileName}
          >
            <Link
              className={"usa-link"}
              to={{
                pathname: `/dashboard/profiles/employer/pocs/${profileName.replace(
                  //eslint-disable-next-line
                  /[\\|\/\s]/g,
                  ""
                  //eslint-disable-next-line
                )}/${legalBusinessName.replace(/[\\|\/\s]/g, "")}/${fein}/${
                  original.id
                }`,
              }}
            >
              {profileName}
            </Link>
          </span>
          <ReactTooltip id={profileName} type="dark" effect="solid">
            <div>{profileName}</div>
          </ReactTooltip>
        </Fragment>
      );
    },
  },
  {
    Header: "Employer Name",
    accessor: "EmployerFormData.new_profile_emp_legal_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "FEIN",
    accessor: "EmployerFormData.new_profile_emp_fein",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Number of Profiles",
    accessor: "numberOfPOC",
    Cell: ({ value }) => <span className="cell">{value}</span>,
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("employer", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default employer_columns;
